"use client";

import { c as _c } from "react/compiler-runtime";
import { OfferStatus } from "@opensea/graphql";
import { toLowerCase, toUpperCase } from "@opensea/utils";
import { parseAsArrayOf, parseAsStringLiteral, useQueryState } from "nuqs";
import { useFilterDefaults } from "@/components/layout/FilterDefaultsProvider";
import { QUERY_PARAM_KEYS } from "./keys";
const OFFER_STATUSES = ["all", ...OfferStatus.map(v => toLowerCase(v))];
const parser = parseAsArrayOf(parseAsStringLiteral(OFFER_STATUSES));
export function useOfferStatusQueryParam() {
  const $ = _c(16);
  const {
    offerStatuses: defaultOfferStatuses
  } = useFilterDefaults();
  let t0;
  if ($[0] !== defaultOfferStatuses) {
    t0 = parser.withDefault(defaultOfferStatuses ?? []);
    $[0] = defaultOfferStatuses;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [values, setValues] = useQueryState(QUERY_PARAM_KEYS.offerStatus, t0);
  let onSelectOfferStatus;
  let t1;
  if ($[2] !== setValues || $[3] !== values) {
    const offerStatuses = values.map(_temp);
    onSelectOfferStatus = async function onSelectOfferStatus(status) {
      if (status === "all" && !offerStatuses.includes("ALL")) {
        await setValues(["all"]);
        return;
      }
      const newStatuses = (values.includes(status) ? values.filter(s => s !== status) : [...values, status]).filter(_temp2);
      await setValues(newStatuses.length > 0 ? newStatuses : ["all"]);
    };
    t1 = offerStatuses.flatMap(_temp3);
    $[2] = setValues;
    $[3] = values;
    $[4] = onSelectOfferStatus;
    $[5] = t1;
  } else {
    onSelectOfferStatus = $[4];
    t1 = $[5];
  }
  const returnedOfferStatuses = t1;
  let t2;
  if ($[6] !== setValues) {
    t2 = () => setValues([], {
      clearOnDefault: true
    });
    $[6] = setValues;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== defaultOfferStatuses || $[9] !== setValues) {
    t3 = () => setValues(defaultOfferStatuses ?? []);
    $[8] = defaultOfferStatuses;
    $[9] = setValues;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== onSelectOfferStatus || $[12] !== returnedOfferStatuses || $[13] !== t2 || $[14] !== t3) {
    t4 = {
      offerStatuses: returnedOfferStatuses,
      onSelectOfferStatus,
      clearStatuses: t2,
      resetStatuses: t3
    };
    $[11] = onSelectOfferStatus;
    $[12] = returnedOfferStatuses;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}
function _temp3(status_0) {
  return status_0 === "ALL" ? [] : [status_0];
}
function _temp2(s_0) {
  return s_0 !== "all";
}
function _temp(v) {
  return toUpperCase(v);
}